/**
 * Feature flags the UI knows about.
 *
 * Two kinds live here. An `envVar` flag is decided at build time and read
 * straight from the environment. A `remote` flag is decided per user by the
 * backend and arrives from `GET /feature-flags`, which resolves it against the
 * user, their active school, their client and their educator type — `key` is
 * the name it carries in that response.
 *
 * `defaultValue` is what a remote flag reads as before its fetch resolves, and
 * what it falls back to if the request fails, so a gated surface stays hidden
 * rather than flashing in while the answer is in flight.
 */
export const FEATURE_FLAGS = {
  deterministicReportInputs: {
    remote: true,
    key: "deterministic_report_inputs",
    defaultValue: false,
  },
  // Lesson reports on Session History. Default off — targeted per user (the
  // admins today) from the flags admin.
  lessonReport: {
    remote: true,
    key: "lesson_report",
    defaultValue: false,
  },
  // School/District admin reports page. Default off — targeted at the
  // school_administrator / district_administrator educator types from the
  // flags admin.
  schoolReports: {
    remote: true,
    key: "school_reports",
    defaultValue: false,
  },
  // Warm-Up Challenges entry points on Manage Groups and the picker route.
  // Default off — targeted per user from the flags admin.
  warmUpChallenges: {
    remote: true,
    key: "warm_up_challenges",
    defaultValue: false,
  },
};
